export default "__VITE_ASSET__TfiUBRev__"